module.exports = __webpack_public_path__ + "img/bulle_5_choix_metier.c09665cb.png";